import { addCardButtonStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsAddCardButton";
import { cardListStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsCardList";
import { defaultCardStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsDefaultCard";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cardListStyles.leftColumnGridItem = {
    width: [6, 6, 4, 4, 4],
    css: css`
        flex-direction: column;
        >${TypographyStyle}{
            color: ${getColor("secondary")};
        }
    `,
}

cardListStyles.centerColumnGridItem = {
    width: [6, 6, 4, 4, 4],
    css: css`
        flex-direction: column;
        >${TypographyStyle}{
            color: ${getColor("secondary")};
        }
    `,
}

cardListStyles.descriptionText = {
    css: css`
        margin: 5px 10px;
        font-size: 16px;
        color: ${getColor("secondary")};
    `,
}

cardListStyles.titleText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
}

addCardButtonStyles.addCardButton = {
    variant: "primary"
}

defaultCardStyles.titleText = {
    variant: "h3"
}

defaultCardStyles.mainWrapper = {
    css: css`
        background-color: ${getColor("info.contrast")};
        padding: 20px;
    `,
}

defaultCardStyles.descriptionText = {
    css: css`
        margin: 5px 10px 10px;
        color: ${getColor("secondary")};
    `,
}

defaultCardStyles.leftColumnGridItem = {
    width: [6, 6, 4, 4, 4],
    css: css`
        flex-direction: column;
        >${TypographyStyle}{
            color: ${getColor("secondary")};
        }
    `,
}

defaultCardStyles.centerColumnGridItem = {
    width: [6, 6, 4, 4, 4],
    css: css`
        flex-direction: column;
        >${TypographyStyle}{
            color: ${getColor("secondary")};
        }
    `,
}